import { Hotkey } from '@/types/Hotkey.ts';
import { useSessionStore } from '@/stores/SessionStore.ts';
import { eventEmitter } from '@/lib/eventEmitter.ts';
import { startSessionAction } from '@/actions/run/StartSessionAction.ts';
import { hideAppAction } from '@/actions/electron/HideAppAction.ts';
import { quitAppAction } from '@/actions/electron/QuitAppAction.ts';
import { resetAction } from '@/actions/app/ResetAction.ts';
import { dynamicVariableToggleAction } from '@/actions/app/DynamicVariableToggleAction.ts';
import { logger } from '@/lib/logger.ts';
import { selectedProfileToggleAction } from '@/actions/app/SelectedProfileToggleAction.ts';
import { moveAppAction } from '@/actions/electron/MoveAppAction.ts';

export const handleHotkeyPressAction = async (hotkey: Hotkey) => {
    const sessionStore = useSessionStore();
    if (sessionStore.isInsideWebView) {
        logger.debug(`handleHotkeyPressAction called from inside web view, ignoring...`);
        return;
    }

    if (sessionStore.isFullLoading) {
        logger.debug(`handleHotkeyPressAction called while in full load state, ignoring...`);
        return;
    }

    eventEmitter.emit('hotkeyPress', { hotkey });

    switch (hotkey) {
        case Hotkey.ActionX1:
            await startSessionAction(true);
            break;
        case Hotkey.ActionX2:
            await resetAction(true);
            break;
        case Hotkey.ActionX3:
            await hideAppAction();
            break;
        case Hotkey.ActionX4:
            await dynamicVariableToggleAction();
            break;
        case Hotkey.ActionX5:
            await selectedProfileToggleAction();
            break;
        case Hotkey.ActionY1:
            await quitAppAction();
            break;
        case Hotkey.MoveAppUp:
            await moveAppAction('up');
            break;
        case Hotkey.MoveAppDown:
            await moveAppAction('down');
            break;
        case Hotkey.MoveAppLeft:
            await moveAppAction('left');
            break;
        case Hotkey.MoveAppRight:
            await moveAppAction('right');
            break;
    }
};
